import { Component, OnInit, ViewChild } from '@angular/core';
import { interval } from 'rxjs';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import beautify from 'xml-beautifier';
import { ExcelServicesService } from '../Shared/Service/excel-services';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-booking-ch-fn-newpipe',
  templateUrl: './booking-ch-fn-newpipe.component.html',
  styleUrls: ['./booking-ch-fn-newpipe.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class BookingChFnNewpipeComponent implements OnInit {
  isProgressing: Boolean = false;
  Userid: any = [];
  apiresult: any;
  hotellist: any = [] = [];
  dropdownDeptData: any;
  hotellistproperty: any;
  heartBeatData: any;
  selectedDeptItems: any;
  searchBarFilter: boolean = false;
  ValSearchDownload: string;
  totalcount: any = 0;
  public Pmscodevalue: any;
  constructor(private apiCallIdsService: DashboarduiService,private datePipe: DatePipe,private toastr: ToastrService,private excelService: ExcelServicesService) { }
  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = false
  }
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  addBtnDisabledFunc: boolean = true;
  hotelSearchDataStatus: any;
  productType: any;
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  excelFunction: boolean = false;
  lstgetcmlist: any = [];
  PGF: any = "0";
  PGT: any = "50";
  selectedChannel: any;
  dropdownSettingsDept: IDropdownSettings = {};
  lstBookingCopy: any = [] = [];
  lstBooking: any = [] = [];
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  searchValueData: any;
  filterProperty: any;
  pageSize = 50;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  status: any = [] = [];
  XMLName: any;
  display: Boolean = false;
  defaultData: any = [] = [];
  XMLTitle: string;
  today = new Date();
  displayedColumns: string[] = ['OTA#', 'PMS#','Echotoken', 'guestName', 'resstatus', 'status','remarks', 'crdt', 'lsdt', 'req','res','resack','reTryCnt' ];
  ngOnInit() {
      this.ValSearchDownload = ''
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.isProgressing = true;
    this.apiCallIdsService.getbookingfromchtofnnewpipeproperty()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.hotellist = this.apiresult
          this.dropdownDeptData = this.apiresult
          console.log('Property 113 = ', this.hotellist)
          this.hotellistproperty = this.hotellist;
          this.isProgressing = false;
        });
      }
      changePropertySearch() {
        if (this.selectedDeptItems) {
          if (this.selectedDeptItems.length > 0) {
            console.log('if condition')
            this.totalcount = 0
            this.Pmscodevalue = this.selectedDeptItems[0].pmscode
            console.log('pms code value = ', this.Pmscodevalue)
            this.errorMsgSubscription = true
            this.errorMessage = "Please select property and load"
            this.displayContent = false
    
            var result = this.apiresult.filter((obj: { pmscode: MatSelectChange; }) => obj.pmscode == this.Pmscodevalue);
            console.log('filter record = ', result);
            this.lstgetcmlist = result;
            this.selectedChannel = this.lstgetcmlist[0].cmcode;
            // For Online Status
            this.apiCallIdsService
              .readHotelSearch(this.Pmscodevalue)
              .subscribe((data) => {
                console.log('readHotelSearch =', data)
                this.hotelSearchDataStatus = data[0].recordstatus
                this.productType = data[0].producttype
              });
            this.apiCallIdsService
              .readHeartbeat(this.Pmscodevalue)
              .subscribe((data) => {
                console.log('readHeartbeat =', data[0])
                this.heartBeatData = data[0].heartBeat
    
    // For blinking the record
    const today = new Date()
    console.log('Today Date = ',today);
    this.currentDateStore = today.toLocaleTimeString('it-IT')
    console.log('Today Date = ',this.currentDateStore);
    this.storeHeartBeatValue = this.GetParseonlyDateTimeBlink(this.heartBeatData)
    var start = this.storeHeartBeatValue.split(":");
    var end = this.currentDateStore.split(":");
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);
    // console.log('minutes difference',minutes)
    console.log('minutes difference', hours + ":"  + minutes)
    if((hours + ":"  + minutes) > "0:30"){
      console.log('blinkOfflineHotel true')
      this.blinkOfflineHotel = true
    }else{
      console.log('blinkOfflineHotel false')
      this.blinkOfflineHotel = false
    }
    
    
              });
            interval(2000 * 60).subscribe(() => {
              this.heartbeatFunction();
            });
          } else {
            console.log('Else condition zero')
            this.errorMsgSubscription = true
            this.errorMessage = "Please select property and load"
            this.displayContent = false
          }
        } else {
          console.log('Property Not Selected')
        }
      }
    
      heartbeatFunction(){
        this.apiCallIdsService
        .readHeartbeat(this.Pmscodevalue)
        .subscribe((data) => {
          console.log('readHeartbeat =',data[0])
          this.heartBeatData = data[0].heartBeat
        });
      }
      GetParseonlyDateTimeBlink(d:any) {
        console.log('GetParseonlyDateTime call',d.substring(12))
        return (d.substring(12));
      }
      GetCommonMethodForLog(ValSearchDownload:any) {
        console.log('ValSearchDownload = ',ValSearchDownload)
        this.searchValueData = ValSearchDownload
        this.PGF = "0";
        this.PGT = "50";
        this.GetBooking()
    
      }
      GetBooking() {
        console.log(this.selectedChannel)
        console.log(this.Pmscodevalue)
        this.isProgressing = true;
        this.lstBooking = [];
        this.lstBookingCopy = [];
        this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
        this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
        if (this.selectedTOODate < this.selectedDate) {
          this.isProgressing = false;
          this.toastr.error('From date should be less than To date.');
        }
        else {
          this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
       
    console.log('searchValueData =',this.searchValueData)
        this.apiCallIdsService.readbookingfromchtofnnewpipe(this.Pmscodevalue, this.selectedChannel, this.selectedDate, this.selectedTOODate,this.PGF, this.PGT,this.searchValueData)
          .subscribe(
            data => {
                    /* Manually insert ischecked as 0 */
                    for (let i = 0; i < data.length; i++) {
                      data[i]['ischecked'] = 0
                   }
                   console.log('After insert ischecked',data);
                   console.log('data.length',data.length);
              if (data.length < 1 || data[0].totalCount == 0){
                this.displayContent = false
                this.errorMsgSubscription = true
                this.errorMessage = "No Data Found"
                this.toastr.error('No Data Found');
                this.isProgressing = false;
                this.excelFunction = false
              }else{
                this.errorMsgSubscription = false
                this.displayContent = true
                this.filterProperty = data
                this.idsProductList = data;
                this.totalcount = data[0].totalCount
                this.dataSource = new MatTableDataSource(this.idsProductList);
                console.log('dataSource = ',this.dataSource);
                this.dataSource.paginator = this.paginator;
                this.toastr.success('Data Loaded Successfully');
                this.isProgressing = false;
                this.excelFunction = true;
              }
            });
          }
      }
      pageEvent(e:any) {
        console.log('pageEvent = ', e)
        var pageIndex = e.pageIndex;
        pageIndex = pageIndex;
        console.log('pageIndex = ', pageIndex)
        this.pageSize = e.pageSize
        console.log('pageSize = ', this.pageSize)
        this.PGF = this.pageSize * pageIndex + 1;
        this.PGT = this.PGF + e.pageSize - 1;
        console.log("this.PGF", this.PGF)
        console.log("this.PGT", this.PGT)
        this.GetBooking();
      }
      showXmlNewpipe(xmltype:any, token:any){
        this.isProgressing = true;
        this.apiCallIdsService.readxmlbookingfromchtofnnewpipe(token, xmltype)
        .subscribe(data => {
          console.log('XML Response =',data)
          if (data.length > 0 && xmltype == "Request") {
            console.log(xmltype);
            const xml = beautify(data[0].jsonData);
            this.XMLName = "Request"
            this.defaultData = xml;
            this.display = true;
            this.isProgressing = false;
          }
    
          else if (data.length > 0 && xmltype == "Response") {
            console.log(xmltype);
            const xml = beautify(data[0].jsonData);
            console.log(xml);
            this.XMLName = "Response"
            this.defaultData = xml;
            this.display = true;
            this.isProgressing = false;
          }
          else if (data.length > 0 && xmltype == "ResAck") {
            console.log(xmltype);
            const xml = beautify(data[0].jsonData);
            console.log(xml);
            this.XMLName = "Response Ack"
            this.defaultData = xml;
            this.display = true;
            this.isProgressing = false;
          }
          else if (data.length < 1) {
            this.toastr.error('No data Found');
            this.isProgressing = false;
          }
        },
          error => {
            this.toastr.error("Falied to load requests !");
            this.isProgressing = false;
          },
        );
      }
      closeModalDialog() {
        this.display = false; //set none css after close dialog
      }
      exportAsXLSX() {
        this.Userid = localStorage.getItem("Username");
        console.log(this.Userid)
        var filterArray = [];
        var slno = 1;
        const excelTitle = "Bookings from Channels to FN New Pipe";
        const excelDownloadTitle = "Bookings from Channels to FN New Pipe";
        const title = "Title: " + excelTitle;
        const role = "Role: " + "IDS User";
        const bindFirstName = "EmailId: " + this.Userid;
        const header = ['S.NO','Hotel Code','OTA#', 'PMS#','Echotoken', 'guestName', 'resstatus', 'status','remarks', 'crdt', 'lsdt', 'req','res','resack','reTryCnt' ];
        for (var i in this.filterProperty) {
          filterArray.push([
            slno,this.filterProperty[i].pmscode, this.filterProperty[i].crsreservationnumber, this.filterProperty[i].pmsreservationnumber,this.filterProperty[i].token, this.filterProperty[i].guestName, this.filterProperty[i].resstatus,this.filterProperty[i].status,this.filterProperty[i].remarks, this.datePipe.transform(this.filterProperty[i].crdt, 'dd-MMM-yyyy, HH:mm'),this.datePipe.transform(this.filterProperty[i].lsdt, 'dd-MMM-yyyy, HH:mm'),"JSON","JSON","JSON",this.filterProperty[i].reTryCnt
          ])
          slno = slno + 1;
        }
    
        this.excelService.ExcelBookingsfromChannelstoFNNewPipe(filterArray, bindFirstName, title, role, header, excelTitle, excelDownloadTitle);
      }
}


